import { Button, ButtonVariant, Label, LabelProps } from "@mcleod/components";
import { AbstractLinePanel } from "./AbstractLinePanel";
import { ImageName } from "@mcleod/images";
import { Navigation, StringUtil } from "@mcleod/core";
import { LiveDemoDef } from "./LiveDemoDef";

export class LiveDemoLinePanel extends AbstractLinePanel {
    protected override build(name?: string, demoDef?: LiveDemoDef) {
        const labelName = new Label({ ...this.getNameColumnDef(name) });
        this.add(labelName);
        const labelDescr = new Label({ ...this.getDescrColumnDef(demoDef?.description) });
        this.add(labelDescr);
        this.addOpenColumn(demoDef);
    }

    protected getNameColumnDef(text: string = ""): Partial<LabelProps> {
        return { text, width: 350, fontBold: true };
    }

    protected getDescrColumnDef(text: string = ""): Partial<LabelProps> {
        return { text, fillRow: true };
    }

    protected addOpenColumn(demoDef: LiveDemoDef) {
        const buttonOpen = new Button({
            imageColor: "primary",
            imageHeight: 21,
            imageName: ImageName.popout,
            imageWidth: 21,
            marginRight: 8,
            variant: ButtonVariant.round
        });
        const layoutPath = demoDef?.layoutPath;
        if (!StringUtil.isEmptyString(layoutPath)) {
            buttonOpen.addClickListener(() => Navigation.navigateTo(layoutPath, { newTab: true }));
        }
        this.add(buttonOpen);
    }
}
